module.exports = "https://cdn.thelire.com/ins/resource/clock@3x.84e4922e8417c603fb622c9c47c75d44.png";